<template>
  <div class="knowledge ">
    <headd></headd>
    <indexswiper :swiper_list="swiper_list"></indexswiper>
    <div class="knowledge_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_16_1.png" />
          </div>
          发明专利申请
        </div>
      </div>
      <modulelist3 :modulelist="zhishiFamingCombo"></modulelist3>
    </div>
    <div class="knowledge_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_16_2.png" />
          </div>
          实用新型专利申请
        </div>
      </div>
      <modulelist2
        :modulelist="zhishiShiyongCombo"
        :is_show="is_show"
      ></modulelist2>
    </div>
    <div class="knowledge_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_16_3.png" />
          </div>
          外观设计专利申请
        </div>
      </div>
      <modulelist2
        :modulelist="zhishiWaiguanCombo"
        :is_show="is_show"
      ></modulelist2>
    </div>
    <div class="knowledge_mo container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_16_4.png" />
          </div>
          专利驳回复审
        </div>
      </div>
      <modulelist1 :modulelist="zhishiBackreviewCombo"></modulelist1>
    </div>
    <div class="knowledge_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_16_1.png" />
          </div>
          版权服务
        </div>
      </div>
      <div class="module_list_3">
        <div class="module_item_1">
          <div class="row">
            <div
              class="col-lg-3 col-md-3 col-sm-4 col-xs-6"
              v-for="item in zhishiBanquanCombo"
              :key="item.id"
            >
              <div class="m_i_1_1" @click="goproductDetail(item.id)">
                <div class="m_i_1_icon">
                  <img :src="item.iconpath" />
                </div>
                <div class="m_i_1_text">{{ item.title }}</div>
                <div class="m_i_1_desc">{{ item.subtitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <dynamicimg :datainfo="dy_title_t1"></dynamicimg>
    <maybe :is_include="name"></maybe>
    <foot></foot>
  </div>
</template>

<script>
import indexswiper from "../components/indexswiper.vue";
import indexbanner from "../components/indexbanner.vue";
import maybe from "../components/maybe.vue";
import anews from "../components/anews.vue";
import dynamicimg from "../components/dynamicimg.vue";
import modulelist1 from "../components/modulelist1.vue";
import modulelist2 from "../components/modulelist2.vue";
import modulelist3 from "../components/modulelist3.vue";
import headd from "../components/head";
import foot from "@/components/foot";
import {
  getzhishiCombobanner,
  getzhishiFamingCombo,
  getzhishiShiyongCombo,
  getzhishiWaiguanCombo,
  getzhishiBackreviewCombo,
  getzhishiBanquanCombo,
  getzhishiPageData
} from "./api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      name: "代理记账",

      dy_title_t1: {
        icon: "../../static/otherpage/icon_8.png",
        title: "服务流程",
        pagevalue: require("../../static/otherpage/page_4_1.png")
      },

      indicatorDots: true,
      autoplay: true,
      interval: 2000,
      duration: 500,
      indicatorColor: "rgba(255, 255, 255, .3)",
      indicatorActivecolor: "#FFFFFF",
      texts: "测试数据",
      swiper_list: [],
      combos: [],
      zhishiFamingCombo: [],
      ServiceBackCombo: [],
      HotCombo: [],
      adbanner_list: [],
      is_show: true,
      zhishiBanquanCombo: [],
      zhishiShiyongCombo: [],
      zhishiWaiguanCombo: [],
      zhishiBackreviewCombo: []
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexbanner,
    indexswiper,
    maybe,
    anews,
    dynamicimg,
    modulelist1,
    modulelist2,
    modulelist3,
    headd,
    foot
  },
  async mounted() {
    var swiperr = await getzhishiCombobanner();
    this.swiper_list = swiperr.data.data.banner;
    this.$nextTick(function() {
      this.swiper();
    });

    var zhishiFamingCombo = await getzhishiFamingCombo();
    this.zhishiFamingCombo = zhishiFamingCombo.data.data.combos;

    var zhishiShiyongCombo = await getzhishiShiyongCombo();
    this.zhishiShiyongCombo = zhishiShiyongCombo.data.data.combos;

    var zhishiWaiguanCombo = await getzhishiWaiguanCombo();
    this.zhishiWaiguanCombo = zhishiWaiguanCombo.data.data.combos;

    var zhishiBackreviewCombo = await getzhishiBackreviewCombo();
    this.zhishiBackreviewCombo = zhishiBackreviewCombo.data.data.combos;

    var zhishiBanquanCombo = await getzhishiBanquanCombo();
    this.zhishiBanquanCombo = zhishiBanquanCombo.data.data.combos;

    var regPageData = await getzhishiPageData();
    var data = regPageData.data.data;

    this.dy_title_t1 = data.t1;

    this.$set(this.dy_title_t1, "icon", "../../static/otherpage/icon_t_8.png");
  },
  methods: {
    goproductDetail(id) {
      this.$router.push({
        path: "productdetail",
        query: {
          id: id
        }
      });
    },
    swiper() {
      new Swiper(".banner", {
        loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000
      });
    }
  }
};
</script>

<style lang="less">
.knowledge {
  flex-direction: column;
  @media (max-width: 991px) {
    width: 6.86rem;
  }
  margin: auto;

  .knowledge_mo {
    margin-bottom: 0.2rem;
    flex-direction: column;
    @media (max-width: 991px) {
      padding: 0;
    }
  }

  .knowledge_recommd {
    flex-direction: column;
    @media (max-width: 991px) {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/knowledge.vue